/* eslint-disable no-alert */
import React from 'react';
import Helmet from 'react-helmet';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';
import Header from '../common/Header';
import Card from './Card';
import { Link, browserHistory } from 'react-router';
import { branch } from 'baobab-react/higher-order';
import tree from '../../state';
import * as productService from '../../services/productService';
import renderHTML from 'react-render-html';

class Results extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedSize: '',
			selectedLockType: '',
			selectedProtection: '',
			products: []
		};
	}

	componentDidMount() {
		const selectedSize = sessionStorage.getItem('selectedSize');
		const selectedLockType = sessionStorage.getItem('selectedLockType');
		const selectedProtection = sessionStorage.getItem('selectedProtection');
		const query = {
			size: selectedSize,
			lockType: selectedLockType,
			protectionFrom: selectedProtection
		};
		const data = Object.assign({}, query, '');
		productService.productSearch(data).then(result => {
			tree.set('productSearchResults', result);
		});
		this.setState({
			selectedSize,
			selectedLockType,
			selectedProtection
		});
	}

	addToCompare(event) {
		const productArr = this.state.products;
		const index = productArr.indexOf(event);

		if (index > -1) {
			productArr.splice(index, 1);
			this.setState({ products: productArr });
		} else {
			this.setState({ products: this.state.products.concat(event) });
		}
	}

	clickCompare() {
		if (this.state.products.length > 4) {
			alert('Please select a maximum of 4 products to compare.');
		} else if (this.state.products.length < 2) {
			alert('Please select at least 2 products to compare.');
		} else {
			// console.dir(`execute ${this.state.products}`);
			browserHistory.push(`/product-compare/${this.state.products}`);
		}
	}

	render() {
		const { selectedSize, selectedLockType, selectedProtection } = this.state;
		let { products } = this.props;
		if (products !== null) {
			const productCount = products.products.length;
			products = products.products.map((item, index) => {
				let html;
				if (!item.tile) {
					html = (
						<li className="col md-3" key={index}>
							<Card
								product={item}
								addToCompare={event => this.addToCompare(event)}
								clickCompare={() => this.clickCompare()}
								canCompare={productCount >= 2}
							/>
						</li>
					);
				}
				return html;
			});
		}
		let selectedProtectionName = selectedProtection;
		if (selectedProtection === 'Theft') {
			selectedProtectionName = 'Theft';
		} else if (selectedProtection === 'Fire') {
			selectedProtectionName = 'Fire & Theft';
		} else if (selectedProtection === 'Water & Fire') {
			selectedProtectionName = 'Water / Fire / Theft';
		}

		return (
			<div className="safe-selector">
				<Helmet>
					<title>Safe Selector | SentrySafe</title>
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Safe Selector" />
				</Breadcrumb>

				<div className="steps-progress">
					<ol>
						<li className="on">
							<Link
								to="/safe-selector/capacity"
								onClick={e => {
									global.dataLayer.push({
										event: 'Product Selector',
										eventCategory: 'Product Selector',
										eventAction: 'Link',
										eventLabel: e.target.textContent
									});
								}}
							>
								Capacity
							</Link>
						</li>
						<li className="on">
							<Link
								to="/safe-selector/lock-type"
								onClick={e => {
									global.dataLayer.push({
										event: 'Product Selector',
										eventCategory: 'Product Selector',
										eventAction: 'Link',
										eventLabel: e.target.textContent
									});
								}}
							>
								Lock Type
							</Link>
						</li>
						<li className="on">
							<Link
								to="/safe-selector/protection"
								onClick={e => {
									global.dataLayer.push({
										event: 'Product Selector',
										eventCategory: 'Product Selector',
										eventAction: 'Link',
										eventLabel: e.target.textContent
									});
								}}
							>
								Protection
							</Link>
						</li>
						<li className="on active">
							<span>Results</span>
						</li>
					</ol>
				</div>

				<Header
					title="Well done!"
					description="Based on your selections, these safes should fit your needs."
				/>

				<span className="arrow-down" />

				<section className="section section-select-safe-results pt-4 pb-5">
					<div className="section-content row text-center">
						<div className="col">
							<h2 className="assistive-text">Results</h2>
							<div className="selection-summary mb-4">
								<strong>Selection Summary:</strong>
								<ul>
									{
										selectedSize ?
											renderHTML(`<li key="1">${selectedSize}</li>`) : ''
									}
									{
										selectedLockType ?
											renderHTML(`<li key="2">${selectedLockType}</li>`) : ''
									}
									{
										selectedProtection ?
											renderHTML(`<li key="3">${selectedProtectionName}</li>`) : ''
									}
								</ul>
								<Link
									className="edit-selections"
									to="/safe-selector/capacity"
									onClick={() => {
										global.dataLayer.push({
											event: 'Product Selector',
											eventCategory: 'Product Selector',
											eventAction: 'Edit Selections',
											eventLabel: global.location.pathname
										});
									}}
								>
									Edit Selections <span className="fa fa-undo" aria-hidden="true" />
								</Link>
							</div>
							<div className="select-safe-results">
								<ul className="list-unstyled row my-0">
									{products}
								</ul>
							</div>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default branch({
	products: ['productSearchResults']
}, Results);


// WEBPACK FOOTER //
// ./src/pages/safeSelector/Results.js